<template>
  <div id="app">
    <el-container>
      <el-header>
        <navbar></navbar>
      </el-header>
      <el-main class="clearpm">
        <router-view></router-view>
      </el-main>
      <el-footer class="clearpm">
				<yw-footer></yw-footer>
			</el-footer>
    </el-container>
  </div>
</template>

<script>
import navbar from "./components/nav.vue";
import footer from "./components/footer.vue";


function browserRedirect() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        console.log("！移动端");
        // if (location.href.indexOf('/mobile')==-1) {
          location.href = "/mobile";
        // }
    } else {
        // const mUrl = location.origin + location.pathname.replace(/m/, "p") + location.search;
        console.log('!电脑端');
        
        if (location.href.indexOf('/mobile')>-1) {
          location.href = "/";
        }
    }
}
    
    
export default {
  name: 'App',
  components:{
    navbar,
		ywFooter: footer
  },
  created(){
    browserRedirect();
  }
}
</script>

<style lang="less">
@import "./src/assets/css/main.less";
</style>

